import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components/macro';
import { WxLabel } from '../..';
import { COLORS } from '../../../styles/colors';
import { breakpoint } from '../../../styles/constants';

interface Props {
  pages: number;
  activePage: number;
  setActivePage: (page: number) => void;
}

export const Pagination = ({ pages, activePage, setActivePage }: Props) => {
  const getPages = () => {
    const el = [];
    for (let i = 1; i <= pages; i++) {
      el.push(
        <Li
          onClick={() => {
            setActivePage(i);
            window.scrollTo(0, 0);
          }}
          key={i}
          active={i === activePage}
        >
          <WxLabel label={i.toString()} />
        </Li>,
      );
    }
    return el;
  };

  return (
    <Container>
      <IconContainer
        active={activePage > 1}
        onClick={() => {
          setActivePage(activePage - 1);
          window.scrollTo(0, 0);
        }}
        disabled={activePage === 1}
      >
        <FontAwesomeIcon icon={faArrowLeft} size={'sm'} />
      </IconContainer>
      <Pages>{getPages()}</Pages>
      <IconContainer
        active={activePage < pages}
        onClick={() => {
          setActivePage(activePage + 1);
          window.scrollTo(0, 0);
        }}
        disabled={pages === activePage}
      >
        <FontAwesomeIcon icon={faArrowRight} size={'sm'} />
      </IconContainer>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 3.75rem;
  display: flex;
  justify-content: space-between;
`;

const IconContainer = styled.div<{ active: boolean; disabled: boolean }>`
  pointer-events: ${({ active }) => (active ? 'all' : 'none')};
  aspect-ratio: 1;
  width: 2.625rem;
  background-color: ${({ theme }) => theme.colors.red};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.white};
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  cursor: pointer;

  @media (min-width: ${breakpoint}) {
    width: 3rem;
  }

  &:hover {
    background-color: ${COLORS.white};
    color: ${COLORS.red};
  }
`;

const Pages = styled.ul`
  display: flex;
  align-items: center;
  gap: 0.625rem;

  > li {
    cursor: pointer;
  }
`;

const Li = styled.li<{ active: boolean }>`
  cursor: pointer;
  min-width: 32px;
  display: flex;
  justify-content: center;
  padding-block: 5px;
  ${({ active }) =>
    active &&
    css`
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.red}`};
      outline-offset: 5px;
    `};
`;
